export interface IResetPasswordProps {}

export const STATE_IDENTIFIER = {
  ACCOUNTS: "accounts",
  REQUEST_STATE: "requestState",
  GENERATE_OTP_RECEIVER: "generateOTPReceiver",
  UIGP_OTP_VERIFIED: "uiugpOtpVerified",
};

export const LIST_IDENTIFIER = "list";

export const LOADER_IDENTIFIER = "loader";
